let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("CDTCX")).then(() => parcelRequire('a8qag'));